import { render, staticRenderFns } from "./JobAssignmentOrderInfo.vue?vue&type=template&id=ca888d60&scoped=true&"
import script from "./JobAssignmentOrderInfo.vue?vue&type=script&lang=js&"
export * from "./JobAssignmentOrderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca888d60",
  null
  
)

export default component.exports